import DataProviderInstancesClient from "../../api/clients/dataProviders/DataProviderInstancesClient"
import { OrganizationPropertiesClient } from "../../api/clients/identity/OrganizationPropertiesClient"
import { ActivityTag, SignalResource } from "../../api/clients/workflows/DTOs"
import TagsClient from "../../api/clients/workflows/TagsClient"
import WorkflowsClient from "../../api/clients/workflows/WorkflowsClient"

export const queryDataProviderById = async (instanceId: number, parameters: Record<string, string>, signal?: AbortSignal) => {
	const dataProviderApi = new DataProviderInstancesClient()

	return (await dataProviderApi.execute(instanceId, parameters, signal)).data
}

export const queryDataProviderByName = async (
	name: string,
	parameters: Record<string, string>,
	signal?: AbortSignal
) => {
	const dataProviderApi = new DataProviderInstancesClient()

	return (await dataProviderApi.executeByName(name, parameters, signal)).data
}

export const getOrganizationPropertyValueByName = async (propertyName: string) => {
	const organizationPropertiesApi = new OrganizationPropertiesClient()

	const { data: property } =
		await organizationPropertiesApi.GetPropertyByName(propertyName)

	return property.value?.value
}

export const startWebHookWorkflow = async (tags: ActivityTag[], signalTypeId: string, resources: SignalResource[]) => { 
	const workflowTagsClient = new TagsClient()
	const workflowsClient = new WorkflowsClient()

	const { data: workflowDefinitions } =
		await workflowTagsClient.queryWorkflows(tags)

	if (workflowDefinitions.length === 0)
		return
	
	const workflowDefinition = workflowDefinitions[0]

	const { data: startedWorkflowModel } =
		await workflowsClient.createWorkflowSignal(
			workflowDefinition.id,
			signalTypeId,
			resources,
		)
	
	return startedWorkflowModel
}

export const getWorkflowStatus = async (workflowInstanceId: number) => {
	const workflowsClient = new WorkflowsClient()

	const { data: status } = await workflowsClient.getWorkflowStatus(workflowInstanceId)

	return status
}